// documentTemplates.js

// Базовые стили для всех документов (А4 формат)
const baseStyles = `
  <style>
    body { font-family: 'Times New Roman', Times, serif; margin: 0; padding: 20px; background: #525659; }
    .page { background: white; width: 210mm; min-height: 297mm; margin: 0 auto; padding: 20mm; box-sizing: border-box; box-shadow: 0 0 10px rgba(0,0,0,0.5); }
    table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 14px; }
    th, td { border: 1px solid black; padding: 5px; text-align: left; }
    th { background-color: #f2f2f2; text-align: center; }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .bold { font-weight: bold; }
    .stamp { color: red; border: 2px solid red; border-radius: 50%; display: inline-block; padding: 10px; transform: rotate(-15deg); opacity: 0.7; font-weight: bold; margin-top: 20px; }
    h1, h2 { text-align: center; }
    .signature-block { display: flex; justify-content: space-between; margin-top: 40px; }
    .signature-line { border-bottom: 1px solid black; width: 200px; display: inline-block; margin: 0 10px; }
  </style>
`;

export const generateInvoice = (order) => {
  return `
    <html><head><meta charset="utf-8"><title>Invoice ${order.invoice_no}</title>${baseStyles}</head>
    <body>
      <div class="page">
        <h2>RusChina Business Consulting Co., Ltd.</h2>
        <p class="text-center">D-1718-2, Heyuan Commercial Center, Heyuan, Guangdong, China</p>
        <h1>Commercial Invoice</h1>
        
        <table>
          <tr>
            <td rowspan="4" width="40%">
              <b>Invoice To:</b><br>
              ${order.client?.official_name || 'ИП Армянинов Никита Игоревич'}<br>
              ${order.client?.address || '21A Sovetskaya ulitsa, Apt 25, Izhevsk'}
            </td>
            <td width="30%">Invoice No.:</td>
            <td width="30%">${order.invoice_no || 'IEANI20260514-2'}</td>
          </tr>
          <tr><td>Invoice Date:</td><td>${order.date || '2026/6/26'}</td></tr>
          <tr><td>Payment Terms:</td><td>by T/T 100% before shipment</td></tr>
          <tr><td>Contract No.:</td><td>${order.contract_no || 'IEANI20260514'}</td></tr>
        </table>

        <table>
          <thead>
            <tr>
              <th>Item No.</th><th>Description</th><th>Model</th><th>Qty</th><th>Unit</th><th>Unit Price (CNY)</th><th>Amount (CNY)</th>
            </tr>
          </thead>
          <tbody>
            ${(order.items || []).map((item, idx) => `
              <tr>
                <td class="text-center">${idx + 1}</td>
                <td>${item.description}</td>
                <td>${item.model}</td>
                <td class="text-right">${item.qty}</td>
                <td class="text-center">PCS</td>
                <td class="text-right">${item.unit_price}</td>
                <td class="text-right">${item.amount}</td>
              </tr>
            `).join('')}
            <tr>
              <td colspan="6" class="text-right bold">Freight</td>
              <td class="text-right">${order.freight || '64169.36'}</td>
            </tr>
            <tr>
              <td colspan="6" class="text-right bold">TOTAL</td>
              <td class="text-right bold">${order.total_amount || '610620.41'}</td>
            </tr>
          </tbody>
        </table>

        <div style="border: 1px solid black; padding: 10px; font-size: 12px; margin-top: 20px;">
          <b>REMIT TO:</b><br>
          BENEFICIARY'S BANK: VTB BANK (PJSC) SHANGHAI BRANCH<br>
          SWIFT BIC: VTBCRNSH<br>
          BENEFICIARY'S A/C NO.(CNY): 40807156900610058031<br>
          BENEFICIARY'S NAME: RusChina Business Consulting Co., Ltd.
        </div>
      </div>
    </body></html>
  `;
};

export const generatePackingList = (order) => {
  return `
    <html><head><meta charset="utf-8"><title>Packing List ${order.invoice_no}</title>${baseStyles}</head>
    <body>
      <div class="page">
        <h2>RusChina Business Consulting Co., Ltd.</h2>
        <p class="text-center">D-1718-2, Heyuan Commercial Center, Heyuan, Guangdong, China</p>
        <h1>PACKING LIST</h1>
        
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div>
            <b>INV. NO.:</b> ${order.invoice_no || 'IEANI20260514-2'}<br>
            <b>S/C NO.:</b> ${order.contract_no || 'IEANI20260514'}<br>
            <b>TO:</b> ${order.client?.official_name || 'IE Armianinov Nikita Igorevich'}
          </div>
          <div>
            <b>DATE:</b> ${order.date || '2026-06-15'}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>MARKS</th><th>DESCRIPTION OF GOODS</th><th>QUANTITY</th><th>PACKAGE</th><th>G.W(KGS)</th><th>N.W(KGS)</th><th>MEAS(CBM)</th>
            </tr>
          </thead>
          <tbody>
            ${(order.items || []).map(item => `
              <tr>
                <td class="text-center">N/M</td>
                <td>${item.description}</td>
                <td class="text-right">${item.qty}</td>
                <td class="text-right">${item.package_count || '19'}</td>
                <td class="text-right">${item.gw}</td>
                <td class="text-right">${item.nw}</td>
                <td class="text-right">${item.meas}</td>
              </tr>
            `).join('')}
            <tr>
              <td class="text-center bold">TOTAL</td>
              <td></td>
              <td class="text-right bold">${order.total_qty || ''}</td>
              <td class="text-right bold">${order.total_packages || ''}</td>
              <td class="text-right bold">${order.total_gw || ''}</td>
              <td class="text-right bold">${order.total_nw || ''}</td>
              <td class="text-right bold">${order.total_meas || ''}</td>
            </tr>
          </tbody>
        </table>

        <div style="text-align: right; margin-top: 50px;">
          <p>RusChina Business Consulting Co., Ltd</p>
          <div class="stamp">ПЕЧАТЬ КОМПАНИИ</div>
        </div>
      </div>
    </body></html>
  `;
};

export const generateDelayNotice = (order) => {
  return `
    <html><head><meta charset="utf-8"><title>Notice of Delay</title>${baseStyles}</head>
    <body>
      <div class="page">
        <h2>Notice of shipment delay under Contract No. ${order.contract_no || 'IEANI20260514'}</h2>
        <p>Date: ${new Date().toLocaleDateString('ru-RU')}</p>
        
        <p>Dear Mr. ${order.client?.name || 'Armianov'},</p>
        
        <p>Regarding Sales Contract No. ${order.contract_no || 'IEANI20260514'} dated May 14, 2026, concluded between RusChina Business Consulting Co., Ltd (Seller) and Individual Entrepreneur ${order.client?.name || 'Arminanov Nikita Igorevich'} (Buyer), we hereby inform you that the shipment date of the goods under the above-mentioned Contract has been postponed.</p>

        <p>The delay in shipment is caused by the need for additional time required for preparation and completion of export documentation procedures, as well as related export arrangements necessary for shipment of goods from the People's Republic of China.</p>

        <p>Due to the above circumstances, the Parties have agreed to extend the expected completion date of obligations under Contract No. ${order.contract_no || 'IEANI20260514'}.</p>

        <p>The original expected completion date of obligations under the Contract was <b>August 15, 2026</b>. The updated expected completion date is <b>September 1, 2026</b>.</p>

        <p>The Seller confirms that the goods under the Contract remain scheduled for shipment, and this extension does not affect the validity of the Contract or the obligations of the Parties.</p>

        <div class="signature-block">
          <div>
            <p>Sincerely,</p>
            <p>RusChina Business Consulting Co., Ltd</p>
            <p>Authorized Representative: <span class="signature-line"></span></p>
            <p>Zeng Deliang / Цзэн Дэлэн</p>
            <p>Position: Business Manager</p>
            <div class="stamp">RusChina Stamp</div>
          </div>
        </div>
      </div>
    </body></html>
  `;
};

// Заготовки для остальных сложных документов (УПД, договоры и т.д.)
export const generateUPD = (order) => {
  return `
    <html><head><meta charset="utf-8"><title>УПД по заказу ${order.id}</title>${baseStyles}</head>
    <body>
      <div class="page">
        <h3>Универсальный передаточный документ № ${order.upd_no || '20260817'} от ${order.date || '17.08.2026'}</h3>
        <p><b>Продавец:</b> ИП Армянинов Никита Игоревич, ИНН 026490622509</p>
        <p><b>Покупатель:</b> ИП Васева Юлия Алексеевна, ИНН 183508192453</p>
        
        <table style="font-size: 10px;">
          <thead>
            <tr>
              <th>№</th><th>Наименование товара</th><th>Код ТН ВЭД</th><th>Ед. изм.</th><th>Кол-во</th><th>Цена</th><th>Стоимость без налога</th><th>НДС</th><th>Всего с НДС</th>
            </tr>
          </thead>
          <tbody>
             ${(order.items || []).map((item, idx) => `
              <tr>
                <td class="text-center">${idx + 1}</td>
                <td>${item.description || 'ФЛАКОН ПАРФЮМЕРНЫЙ СТЕКЛЯННЫЙ'}</td>
                <td class="text-center">${item.hs_code || '9616101000'}</td>
                <td class="text-center">шт</td>
                <td class="text-right">${item.qty}</td>
                <td class="text-right">${item.unit_price}</td>
                <td class="text-right">${item.amount}</td>
                <td class="text-center">Без НДС</td>
                <td class="text-right">${item.amount}</td>
              </tr>
            `).join('')}
            <tr>
              <td colspan="8" class="text-right bold">Всего к оплате</td>
              <td class="text-right bold">${order.total_amount || ''}</td>
            </tr>
          </tbody>
        </table>
        
        <div class="signature-block">
          <div>
            <p>Товар передал: ИП Армянинов Н.И. <span class="signature-line"></span></p>
          </div>
        </div>
      </div>
    </body></html>
  `;
};

// Заглушка для Договора комиссии
export const generateCommissionAgreement = (order) => {
  return `<html><head><meta charset="utf-8">${baseStyles}</head><body><div class="page">
    <h1>Договор комиссии № ${order.contract_no || 'ДК-20260414'}</h1>
    <p>Здесь будет сгенерирован полный текст договора, поручений и актов на основе данных заказа.</p>
  </div></body></html>`;
};